/**
 * 文件说明:
 *
 * HzSiderMenu
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, useState} from 'react'
import {useShallowEqualSelector} from 'hooks'
import {useLocation} from 'umi'
import SiderMenu from 'components/hz-layout/sider-menu'

export const parseData = ({data, parent = null, flatData}) => {
    if (data?.children) {
        return data.children.map((item) => {
            const newItem = {
                name: item.name,
                key: item.slug,
                icon: item.icon,
                path: item.url,
                hideInMenu: !!item.hideInMenu,
            }

            if (parent) {
                newItem.parents = [...new Set([parent.key, ...(parent?.parents ?? [])])]
            } else {
                newItem.parents = []
            }

            flatData.push(newItem)

            newItem.children = parseData({
                data: item,
                parent: newItem,
                flatData,
            })

            return newItem
        })
    }

    return []
}

export const getMenuMap = ({pathname, siderMenuMap}) => {
    for (const key of Object.keys(siderMenuMap)) {
        if (pathname?.includes(`/${key}`)) {
            return siderMenuMap[key]
        }
    }

    return {}
}

const HzSiderMenu = memo((props) => {
    const {siderMenuMap} = useShallowEqualSelector(({menu}) => ({
        siderMenuMap: menu.siderMenuMap,
    }))

    const {loading} = props

    const location = useLocation()
    const {pathname} = location

    const [menuOption] = useState(() => {
        const {flatMenuData = [], menuData = []} = getMenuMap({siderMenuMap, pathname})

        return {flatMenuData, menuData}
    }, [siderMenuMap, pathname])

    return (
        <SiderMenu
            menuData={menuOption?.menuData}
            flatMenuData={menuOption?.flatMenuData}
            pathname={location.pathname}
            loading={loading}
        />
    )
})

export default HzSiderMenu
